import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-2">吃瓜评论</h2>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10">吃瓜群众热议精选</p>
        <div className="space-y-4">
          {commentsData.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400 font-bold text-sm flex-shrink-0">
                  {item.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-sm font-medium text-foreground-200">{item.name}</span>
                    <span className="text-xs text-foreground-600">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-400 leading-relaxed mb-3">{item.content}</p>
                  <div className="flex items-center gap-4">
                    <button className="flex items-center gap-1 text-xs text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i>
                      <span>{item.likes.toLocaleString()}</span>
                    </button>
                    <button className="flex items-center gap-1 text-xs text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">
                      <i className="ri-chat-1-line"></i>
                      <span>回复</span>
                    </button>
                    <button className="flex items-center gap-1 text-xs text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer">
                      <i className="ri-share-forward-line"></i>
                      <span>分享</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}